import {LadingStatus} from "@/enums/status";
import {LadingType} from "@/enums/type";
import moment from "moment";
import {LadingPriority} from "@/enums/status/lading";

export class LadingParams {
    page? = 1;
    limit? = 10;
    search?: string;
    type?: LadingType;
    status?: LadingStatus;
    priority?: LadingPriority;
    statusString?: string;
    ladingCode?: string;
    fromDate = moment().startOf('month').valueOf();
    toDate = (new Date()).valueOf();
    fromProvince: undefined;
    toProvince: undefined;
    freightServiceRowGuid: undefined;
    customerRowGuid?: string;
    customerCode?: string;
    acceptanceEmployeeRowGuid?: string;
    acceptancePostOfficeRowGuid?: string;
    deliveryEmployeeRowGuid?: string;
    deliveryPartnerRowGuid?: string;
    deliveryPostOfficeRowGuid?: string;
}
